export { default as Consumi } from './Consumi.vue';
export { default as DistintaDettaglio } from './DistintaDettaglio.vue';
export { default as Login } from "./Login.vue";
export { default as Home } from './Home.vue';
export { default as Lavorazioni } from './Lavorazioni.vue';
export { default as LavorazioneDettaglio } from './LavorazioneDettaglio.vue';
export { default as OrdiniMTM } from './OrdiniMTM.vue';
export { default as Ordini } from './Ordini.vue';
export { default as OrdineDettaglio } from './OrdineDettaglio.vue';
export { default as OrdineMTMDettaglio } from './OrdineMTMDettaglio.vue';
export { default as SpedizioneDettaglio } from './SpedizioneDettaglio.vue';
export { default as NuovaSpedizione } from './NuovaSpedizione.vue';
export { default as StampaDdt } from './StampaDdt.vue';
export { default as Spedizioni } from './Spedizioni.vue';
export { default as Reintegri } from './Reintegri.vue';
export { default as ReintegroDettaglio } from './ReintegroDettaglio.vue';
export { default as Venduto } from './Venduto.vue';
export { default as OrdineSpacchettato } from './OrdineSpacchettato.vue';